export default __webpack_public_path__ + "static/media/TERMINAL_ICON_03.69482b62.svg";